<template>
  <router-view />
</template>

<script> 
import { useAuthStore } from '@/stores/userStore';

export default {
  name: 'App',
  mounted() {
    const authStore = useAuthStore();
    authStore.initCrossTabSync();
  }
};
</script>

<style scoped>
#app {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin-top: 0px;
  line-height: 1.5;
}
 

</style>
